import { ref } from '@vue/composition-api'
import httpClient from '../http/httpClient'

/* eslint-disable import/prefer-default-export */
export const useDashboardRepository = () => {
  const dashboard = ref([])
  const getDashboard = async () => {
    await httpClient.fetchDashboard()
      .then(response => {
        if (response.data.result) {
          dashboard.value = response.data.result
        }
      })
      .catch(() => { })
  }

  return {
    dashboard,
    getDashboard,
  }
}
